import { useMutation } from '@tanstack/react-query';
import {
  WithdrawRequestService,
  ApproveWithdrawRequestEntity,
  ApproveWithdrawRequestDto,
} from 'services/openapi';

export type AcceptRequestWithdrawType = {
  id: string;
  variables: ApproveWithdrawRequestDto;
};

export const useApproveRequestWithdrawMutation = () => {
  const { isLoading, error, data, isError, isSuccess, mutate, mutateAsync } =
    useMutation<ApproveWithdrawRequestEntity, Error, AcceptRequestWithdrawType>(
      {
        mutationFn: (request: AcceptRequestWithdrawType) => {
          return WithdrawRequestService.withdrawRequestControllerApprove(
            request.id,
            request.variables,
          );
        },
      },
    );

  return {
    isLoading,
    isSuccess,
    error,
    data,
    isError,
    mutate,
    mutateAsync,
  };
};
